<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <!-------------- 客户信息 -------------->
        <add-custormer-information
        :payTypeList="payTypeList"
        :industryTypeList="industryTypeList"
        :fromTypeList="fromTypeList"
        :customerType="customerType"
        :implevelType="implevelType"
        :isShow='isShow'
        @addCustormer="addCustormer"
        @onParent='onParent1'
        @onCompanyName="onCompanyName"
        ref="custormerInformationRef">
        </add-custormer-information>
        <!-------------- 联系人信息 -------------->
        <linkman-information
        :isShow='isShow'
        @onParent='onParent2'
        ref="linkmanInformationRef"
        ></linkman-information>
        <!-------------- 开票信息 -------------->
        <open-information
        :isShow='isShow'
        :ciTaxcode='ciTaxcode'
        :ciName='ciName'
        ref="openInformationRef"></open-information>
        <!-------------- 交易账户-银行转账 -------------->
        <trading-account
        :isShow='isShow'
        :cusName='cusName'
        :customerBankList="customerBankList"
        ref="tradingAccountRef"></trading-account>
        <!-------------- 收货信息 -------------->
        <receiving-information
        :isShow='isShow'
        ref="receivingInformationRef"></receiving-information>
        <el-row>
          <el-col :span="24" style="margin-top:20px;">
            <el-button type="primary" @click="onSubmit" v-if="isShow">提 交</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import addCustormerInformation from '@/views/crm/components/custorm/addCustormerInformation'
import linkmanInformation from '@/views/crm/components/supplier/linkmanInformation'
import openInformation from '@/views/crm/components/supplier/openInformation'
import tradingAccount from './tradingAccount'
import { customerBaseAdd } from '@/api/customer/customerManage'
import receivingInformation from '@/views/crm/components/supplier/receivingInformation'
export default {
  data () {
    return {
      customerBankList: [],
      isShow: true,
      payTypeList: [], // 支付类型
      industryTypeList: [], // 所属行业
      fromTypeList: [], // 客户来源
      customerType: [], // 客户类型
      implevelType: [], // 重要等级
      cusName: '',
      ciTaxcode: '',
      ciName: '',
      isF1: false,
      isF2: false
    }
  },
  components: {
    addCustormerInformation,
    linkmanInformation,
    openInformation,
    receivingInformation,
    'trading-account': tradingAccount
  },
  mounted () {
    this.onInitialize()
  },
  methods: {
    addCustormer (val) {
    },
    // 页面初始
    onInitialize () {
      this.height = document.documentElement.clientHeight
      this.getQueryByClassCode()
    },
    // 根据多个分类类型显示属性内容
    async getQueryByClassCode () {
      const params = await this.$queryByClassCode()
      try {
        this.payTypeList = params.payTypeList
        this.industryTypeList = params.industryTypeList
        this.fromTypeList = params.fromTypeList
        this.customerType = params.customerType
        this.implevelType = params.implevelType
      } catch (e) {
        console.log(e)
      }
    },
    // 公司名称
    onCompanyName (val) {
      this.ciTaxcode = val.uncid
      this.ciName = val.entname
      this.cusName = val.entname
    },
    onParent1 () {
      this.isF1 = true
    },
    onParent2 (isBool) {
      this.isF2 = isBool
    },
    // 接收子组件检验是否成功
    onParent () {
      if (this.isF1 && this.isF2) {
        this.customerBankList = this.$refs.tradingAccountRef.queryParams
        const params = {
          customerBase: this.$refs.custormerInformationRef.queryParams,
          customerConnectList: this.$refs.linkmanInformationRef.queryParams,
          customerInvoice: this.$refs.openInformationRef.queryParams,
          customerRecevieInfoList: this.$refs.receivingInformationRef.queryParams,
          customerBankList: this.customerBankList
        }
        customerBaseAdd(params).then(res => {
          if (res.data.code === 200) {
            this.$message.success('添加成功!')
            this.$router.push({
              path: 'myCustomer',
              query: {
                cusState: 'potentialCustomers'
              }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$message.error('必填项不能为空')
      }
    },
    // 提交
    onSubmit () {
      this.$refs.custormerInformationRef.onCustormerRules()
      this.$refs.linkmanInformationRef.onLinkmanRules()
      this.onParent()
      this.$refs.receivingInformationRef.onReceivingRuls()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
